// Centralized localization. Add new languages here without touching game logic.
export const T = {
  es: {
    appTitle: "ARCHIVO BÍBLICO PERDIDO",
    appSubtitle: "¡Recupera las 3 piezas perdidas!",
    // landing
    hostGame: "Crear sala (TV)",
    joinGame: "Unirse como jugador",
    admin: "Administrar contenido",
    landingBlurb: "Una expedición familiar para recuperar tres registros perdidos del archivo bíblico.",
    // host
    createExpedition: "Crear expedición",
    tvLanguage: "Idioma de la TV",
    showTranslation: "Mostrar traducción en TV",
    spanish: "Español", english: "English", bilingual: "Bilingüe",
    roomCode: "CÓDIGO DE SALA",
    joinAt: "Únete en tu teléfono",
    waitingPlayers: "Esperando exploradores…",
    startExpedition: "Comenzar expedición",
    players: "Exploradores",
    noPlayers: "Aún no hay jugadores conectados",
    // join flow
    enterCode: "Ingresa el código de sala",
    codePlaceholder: "4827",
    next: "Siguiente",
    yourName: "¿Cómo te llamas?",
    namePlaceholder: "Tu nombre",
    chooseLanguage: "🌎 Elige tu idioma",
    chooseRank: "Elige tu rango",
    chooseAvatar: "Elige tu avatar",
    chooseAvatarSub: "Toca un personaje para representarte en el mapa.",
    changeAvatar: "Cambiar avatar",
    explorer: "Explorador", explorerAge: "Niños",
    investigator: "Investigador", investigatorAge: "Jóvenes",
    archaeologist: "Arqueólogo", archaeologistAge: "Adultos",
    ready: "✅ Listo para la expedición",
    waitingHost: "Esperando al anfitrión para comenzar…",
    // game
    yourTurn: "¡Es tu turno!",
    turnOf: "Turno de",
    rollDice: "🎲 Lanzar dado",
    rolling: "Lanzando…",
    waitTurn: "Espera tu turno, explorador",
    continue: "Continuar",
    endTurn: "Terminar turno",
    autoContinue: "Continúa automáticamente en {s}s…",
    // dice results
    d1: "Pista privada", d2: "Personaje", d3: "Escoge uno",
    d4: "Lugar", d5: "Contratiempo", d6: "Acontecimiento",
    clueOpportunity: "Oportunidad de pista privada",
    answerToUnlock: "Responde para desbloquear una pista",
    investigateCharacter: "Investigación de personaje",
    investigateEvent: "Investigación de acontecimiento",
    youDecide: "¡Tú decides!",
    chooseCategory: "¿Qué quieres investigar?",
    chooseCandidate: "Elige un candidato",
    chooseCharacter: "Elige un personaje",
    chooseEvent: "Elige un acontecimiento",
    whereTravel: "¿A dónde quieres viajar?",
    chooseDestination: "Elige tu destino",
    traveling: "Viajando…",
    investigation: "Investigación",
    beginsHere: "Tu investigación comienza…",
    // question
    question: "Pregunta",
    // feedback
    correct: "¡Correcto!",
    incorrect: "Casi…",
    incorrectClue: "Respuesta incorrecta",
    correctAnswer: "Respuesta correcta",
    reference: "Referencia",
    clueUnlocked: "🔐 Pista desbloqueada",
    clueLost: "🔒 Pista perdida",
    resultSent: "Resultado enviado al investigador",
    verifying: "Verificando archivo…",
    // private results
    pieceRecovered: "¡Pieza recuperada!",
    notThePiece: "no es la pieza perdida",
    keepSecret: "Mantén esta información en secreto.",
    recovered: "Recuperado",
    discarded: "Descartado",
    yourClue: "Tu pista privada",
    // setback
    setbackTitle: "¡Contratiempo en la expedición!",
    noInvestigate: "No podrás investigar este turno.",
    didYouKnow: "¿Lo sabías?",
    sb_sandstorm: "🌪️ Tormenta de arena",
    sb_caravan: "🐪 Problemas con la caravana",
    sb_lostmap: "🗺️ Mapa perdido",
    sb_blocked: "🏺 Camino bloqueado",
    sb_scroll: "📜 Pergamino ilegible",
    // notebook
    caseFile: "Mi expediente",
    points: "puntos",
    characters: "Personajes", locations: "Lugares", events: "Acontecimientos", clues: "Pistas",
    noClues: "Aún no tienes pistas. ¡Saca un 1 en el dado!",
    unknown: "Desconocido",
    // win
    archiveComplete: "¡Archivo completo!",
    recoveredAll: "Has recuperado las 3 piezas perdidas.",
    recoverArchive: "🚨 Recuperar archivo",
    winnerAnnounce: "ha completado su investigación…",
    lostCharacter: "Personaje perdido",
    lostLocation: "Lugar perdido",
    lostEvent: "Acontecimiento perdido",
    archiveRecovered: "¡Archivo bíblico recuperado!",
    winsExpedition: "gana la expedición",
    newExpedition: "🔄 Nueva expedición",
    person: "Personaje", place: "Lugar", event: "Acontecimiento",
    attention: "¡Atención exploradores!",
    // misc
    // interactions
    reactLabel: "Reacciona",
    rollToMove: "Lanza el dado para avanzar",
    youAdvance: "Avanzas por el mapa…",
    raceTemple: "¡Corre al Templo para ganar!",
    templeOpen: "¡Camino secreto abierto! Corre al Templo",
    streak: "RACHA",
    investigate_character: "Investigación de personaje",
    investigate_location: "Investigación de lugar",
    investigate_event: "Investigación de acontecimiento",
    trapTitle: "¡Trampa! Responde para pasar",
    trapPassed: "¡Pasaste la trampa!",
    trapFail: "Retrocedes casillas",
    restTitle: "Campamento",
    restBody: "Descansas un momento. El turno termina.",
    tile_character: "¡Casilla de Personaje!",
    tile_location: "¡Casilla de Lugar!",
    tile_event: "¡Casilla de Acontecimiento!",
    tile_trap: "¡Trampa!",
    tile_clue: "¡Casilla de Pista!",
    tile_rest: "Campamento",
    tile_step: "Terreno despejado",
    tile_path: "Camino secreto",
    tile_temple: "¡El Templo!",
    tile_start: "Inicio",
    willGetRight: "¿Acertará?",
    yesShort: "Sí", noShort: "No",
    predicted: "¡Ya apostaste!",
    askCouncil: "🧭 Pedir ayuda al consejo",
    councilVoted: "El consejo votó",
    honorScore: "Marcador de honor",
    correctAnswers: "Respuestas correctas",
    believedYes: "creyeron que acertarías",
    believedNo: "dudaron de ti",
    timeUp: "¡Se acabó el tiempo!",
    spectatorHint: "Mira la pregunta y reacciona",
    back: "Volver",
    tile_surprise: "¡Sorpresa!",
    chooseStopTitle: "¿Dónde te detienes?",
    chooseStopSub: "Detente en una situación o avanza la tirada completa",
    stopHere: "Detenerme aquí",
    advanceFull: "Avanzar completo",
    decidingRoute: "está decidiendo su ruta…",
    surpriseTitle: "¡Sorpresa!",
    sfForward: "¡Atajo! Avanzas",
    sfBack: "¡Ups! Retrocedes",
    sfHonor: "¡Tesoro! Ganas honor",
    tilesWord: "casillas",
    myProgress: "Mi progreso",
    searching: "Buscando…",
    notFoundYet: "Sin recuperar",
    stealBtn: "¡ROBAR!",
    stealPrompt: "¿Sabes la respuesta? ¡Róbala por 3 puntos!",
    stealWin: "¡Robaste el turno! +3",
    stealFail: "Fallaste el robo (-1)",
    stealAttempted: "Ya intentaste robar",
    stealOpen: "¡ROBO ABIERTO!",
    turnStolen: "robó el turno",
    youWereRobbed: "¡Te robaron el turno!",
    duelTitle: "¡RETO 1 vs 1!",
    duelVs: "vs",
    youAreDueling: "¡Estás en el reto! Responde:",
    duelAnswered: "Respondido. Esperando…",
    whoWon: "¿Quién ganó el reto?",
    duelWaitVotes: "Esperando los votos…",
    duelWinner: "¡Ganador del reto!",
    duelTie: "¡Empate! Nadie gana puntos",
    duelResolve: "Cerrar votación",
    connecting: "Conectando…",
  },
  en: {
    appTitle: "THE LOST BIBLE ARCHIVE",
    appSubtitle: "Recover the 3 missing pieces!",
    hostGame: "Create room (TV)",
    joinGame: "Join as a player",
    admin: "Manage content",
    landingBlurb: "A family expedition to recover three lost records from the Bible archive.",
    createExpedition: "Create expedition",
    tvLanguage: "TV language",
    showTranslation: "Show translation on TV",
    spanish: "Español", english: "English", bilingual: "Bilingual",
    roomCode: "ROOM CODE",
    joinAt: "Join on your phone",
    waitingPlayers: "Waiting for explorers…",
    startExpedition: "Start expedition",
    players: "Explorers",
    noPlayers: "No players connected yet",
    enterCode: "Enter the room code",
    codePlaceholder: "4827",
    next: "Next",
    yourName: "What's your name?",
    namePlaceholder: "Your name",
    chooseLanguage: "🌎 Choose your language",
    chooseRank: "Choose your rank",
    chooseAvatar: "Choose your avatar",
    chooseAvatarSub: "Tap a character to represent you on the map.",
    changeAvatar: "Change avatar",
    explorer: "Explorer", explorerAge: "Kids",
    investigator: "Investigator", investigatorAge: "Teens",
    archaeologist: "Archaeologist", archaeologistAge: "Adults",
    ready: "✅ Ready for the expedition",
    waitingHost: "Waiting for the host to start…",
    yourTurn: "It's your turn!",
    turnOf: "Turn of",
    rollDice: "🎲 Roll the die",
    rolling: "Rolling…",
    waitTurn: "Wait for your turn, explorer",
    continue: "Continue",
    endTurn: "End turn",
    autoContinue: "Continues automatically in {s}s…",
    d1: "Private clue", d2: "Character", d3: "Choose one",
    d4: "Location", d5: "Setback", d6: "Event",
    clueOpportunity: "Private clue opportunity",
    answerToUnlock: "Answer to unlock a clue",
    investigateCharacter: "Character investigation",
    investigateEvent: "Event investigation",
    youDecide: "You decide!",
    chooseCategory: "What do you want to investigate?",
    chooseCandidate: "Choose a candidate",
    chooseCharacter: "Choose a character",
    chooseEvent: "Choose an event",
    whereTravel: "Where do you want to travel?",
    chooseDestination: "Choose your destination",
    traveling: "Traveling…",
    investigation: "Investigation",
    beginsHere: "Your investigation begins…",
    question: "Question",
    correct: "Correct!",
    incorrect: "Almost…",
    incorrectClue: "Wrong answer",
    correctAnswer: "Correct answer",
    reference: "Reference",
    clueUnlocked: "🔐 Clue unlocked",
    clueLost: "🔒 Clue lost",
    resultSent: "Result sent to player",
    verifying: "Verifying archive…",
    pieceRecovered: "Piece recovered!",
    notThePiece: "is not the missing piece",
    keepSecret: "Keep this information secret.",
    recovered: "Recovered",
    discarded: "Discarded",
    yourClue: "Your private clue",
    setbackTitle: "Expedition setback!",
    noInvestigate: "You can't investigate this turn.",
    didYouKnow: "Did you know?",
    sb_sandstorm: "🌪️ Sandstorm",
    sb_caravan: "🐪 Caravan trouble",
    sb_lostmap: "🗺️ Lost map",
    sb_blocked: "🏺 Path blocked",
    sb_scroll: "📜 Unreadable scroll",
    caseFile: "My case file",
    points: "points",
    characters: "Characters", locations: "Locations", events: "Events", clues: "Clues",
    noClues: "You have no clues yet. Roll a 1!",
    unknown: "Unknown",
    archiveComplete: "Archive complete!",
    recoveredAll: "You have recovered the 3 missing pieces.",
    recoverArchive: "🚨 Recover archive",
    winnerAnnounce: "has completed their investigation…",
    lostCharacter: "Missing character",
    lostLocation: "Missing location",
    lostEvent: "Missing event",
    archiveRecovered: "Bible archive recovered!",
    winsExpedition: "wins the expedition",
    newExpedition: "🔄 New expedition",
    person: "Character", place: "Location", event: "Event",
    attention: "Attention explorers!",
    // interactions
    reactLabel: "React",
    rollToMove: "Roll the die to advance",
    youAdvance: "Moving across the map…",
    raceTemple: "Race to the Temple to win!",
    templeOpen: "Secret path open! Race to the Temple",
    streak: "STREAK",
    investigate_character: "Character investigation",
    investigate_location: "Location investigation",
    investigate_event: "Event investigation",
    trapTitle: "Trap! Answer to pass",
    trapPassed: "You passed the trap!",
    trapFail: "You move back",
    restTitle: "Camp",
    restBody: "You rest for a moment. Turn ends.",
    tile_character: "Character tile!",
    tile_location: "Location tile!",
    tile_event: "Event tile!",
    tile_trap: "Trap!",
    tile_clue: "Clue tile!",
    tile_rest: "Camp",
    tile_step: "Open ground",
    tile_path: "Secret path",
    tile_temple: "The Temple!",
    tile_start: "Start",
    willGetRight: "Will they get it right?",
    yesShort: "Yes", noShort: "No",
    predicted: "You predicted!",
    askCouncil: "🧭 Ask the council for help",
    councilVoted: "The council voted",
    honorScore: "Honor scoreboard",
    correctAnswers: "Correct answers",
    believedYes: "believed you'd get it",
    believedNo: "doubted you",
    timeUp: "Time's up!",
    spectatorHint: "Read the question and react",
    back: "Back",
    tile_surprise: "Surprise!",
    chooseStopTitle: "Where do you stop?",
    chooseStopSub: "Stop at a situation or advance the full roll",
    stopHere: "Stop here",
    advanceFull: "Advance full",
    decidingRoute: "is deciding their route…",
    surpriseTitle: "Surprise!",
    sfForward: "Shortcut! Advance",
    sfBack: "Oops! Move back",
    sfHonor: "Treasure! You gain honor",
    tilesWord: "tiles",
    myProgress: "My progress",
    searching: "Searching…",
    notFoundYet: "Not recovered",
    stealBtn: "STEAL!",
    stealPrompt: "Know the answer? Steal it for 3 points!",
    stealWin: "You stole the turn! +3",
    stealFail: "Steal failed (-1)",
    stealAttempted: "You already tried to steal",
    stealOpen: "STEAL OPEN!",
    turnStolen: "stole the turn",
    youWereRobbed: "Your turn was stolen!",
    duelTitle: "1v1 DUEL!",
    duelVs: "vs",
    youAreDueling: "You're in the duel! Answer:",
    duelAnswered: "Answered. Waiting…",
    whoWon: "Who won the duel?",
    duelWaitVotes: "Waiting for votes…",
    duelWinner: "Duel winner!",
    duelTie: "Tie! Nobody scores",
    duelResolve: "Close voting",
    connecting: "Connecting…",
  },
};

export function useT(lang) {
  const l = T[lang] ? lang : "es";
  return (key) => T[l][key] ?? T.es[key] ?? key;
}

export function tt(lang, key) {
  const l = T[lang] ? lang : "es";
  return T[l][key] ?? T.es[key] ?? key;
}

// pick localized field from an entity/question translations object
export function loc(obj, lang, field = "name") {
  if (!obj || !obj.translations) return "";
  const tr = obj.translations[lang] || obj.translations.es || Object.values(obj.translations)[0];
  return tr ? tr[field] : "";
}
